import './style.scss'
import UserIndicator from '../../components/userIndicator/UserIndicator';
import HeaderLogo from './logo/HeaderLogo';

function HeaderPages() {

	return (
		<div className="header-wrap">
			<div className='header-top-wrap'>
				<HeaderLogo />
				<UserIndicator />
			</div>
		</div>
	)
}

export default HeaderPages